import axios from 'axios';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getBaseUrl } from '../BaseUrl';
// const navigate = useNavigate();
export const callApi = async (data = {}, url, method = 'GET') => {
    const apiUrl = process.env.REACT_APP_API_URL+url;
    try {
      const response = await axios({
        url: apiUrl,
        method,
        data,
        headers: {
            'Content-Type': method === 'POST' || method === 'PUT' ? 'multipart/form-data' : 'application/json',
        }
      });
      return response;
    } catch (error) {
      console.error('Error during API call:', error.response ? error.response.data : error.message);
    //   throw error;
    return { success: false, error: error.response ? error.response.data : error.message };

    }
  };

  export const authcallApi = async (data = {}, url, method = 'GET') => {
    const apiUrl = `${process.env.REACT_APP_API_URL}${url}`;
    const token = localStorage.getItem('token');
    let base_url = getBaseUrl();

    try {
        const response = await axios({
            url: apiUrl,
            method,
            headers: {
                'Accept': 'application/json',
               'Content-Type': method === 'POST' || method === 'PUT' ? 'multipart/form-data' : 'application/json charset=UTF-8',
                "Authorization": `Bearer ${token}`,
            },
            data // Pass data as params for GET requests
        });
  
        return response;
    } catch (error) {
        console.error('Error during API call:', error.response ? error.response.data : error.message);
        if(error.response?.data?.message==="Unauthenticated."){
          // navigate(`${base_url}login`);
          window.location.href =`${base_url}login`
          localStorage.setItem("token", "");
        }
        return { success: false, error: error.response ? error.response.data : error.message };
    }
};
  export const authcallApitest = async (data = {}, url, method = 'GET') => {
    
    const apiUrl = `${process.env.REACT_APP_API_URL}${url}`;
    const token = localStorage.getItem('token');
    let base_url = getBaseUrl();

    try {
        const response = await axios({
            url: apiUrl,
            method,
            headers: {
                'Accept': 'application/json',
               'Content-Type': method === 'POST' || method === 'PUT' ? 'multipart/form-data' : 'application/json charset=UTF-8',
                "Authorization": `Bearer ${token}`,
            },
            data // Pass data as params for GET requests
        });
  
        return response;
    } catch (error) {
        console.error('Error during API call:', error.response ? error.response.data : error.message);
        if(error.response?.data?.message==="Unauthenticated."){
          // navigate(`${base_url}login`);
          window.location.href =`${base_url}login`
          localStorage.setItem("token", "");
        }
        return { success: false, error: error.response ? error.response.data : error.message };
    }
};
export const authcallApipost = async (data = {}, url, method = 'GET') => {
  const apiUrl = `${process.env.REACT_APP_API_URL}${url}`;
  const token = localStorage.getItem('token');
  
  try {
      const response = await axios({
          url: apiUrl,
          method,
          headers: {
              'Accept': 'application/json',
             'Content-Type': 'application/json charset=UTF-8',
              "Authorization": `Bearer ${token}`,
          },
          data // Pass data as params for GET requests
      });
      return response;
  } catch (error) {
      console.error('Error during API call:', error.response ? error.response.data : error.message);
      return { success: false, error: error.response ? error.response.data : error.message };
  }
};
 export const callApilivepair = async (data = {}, url, method = 'GET') => {
    const apiUrl = process.env.REACT_APP_LIVE_PAIR_URL+url;
    try {
      const response = await axios({
        url: apiUrl,
        method,
        data,
        headers: {
            'Content-Type': method === 'POST' || method === 'PUT' ? 'multipart/form-data' : 'application/json',
        }
      });
      return response;
    } catch (error) {
      console.error('Error during API call:', error.response ? error.response.data : error.message);
    //   throw error;
    return { success: false, error: error.response ? error.response.data : error.message };

    }
  };
  export const authtockencallApi = async (data = {}, url, method = 'GET',token) => {
    
    const apiUrl = `${process.env.REACT_APP_API_URL}${url}`;
    let base_url = getBaseUrl();

    try {
        const response = await axios({
            url: apiUrl,
            method,
            headers: {
                'Accept': 'application/json',
               'Content-Type': method === 'POST' || method === 'PUT' ? 'multipart/form-data' : 'application/json charset=UTF-8',
                "Authorization": `Bearer ${token}`,
            },
            data // Pass data as params for GET requests
        });
  
        return response;
    } catch (error) {
        console.error('Error during API call:', error.response ? error.response.data : error.message);
        if(error.response?.data?.message==="Unauthenticated."){
          // navigate(`${base_url}login`);
          window.location.href =`${base_url}login`
          localStorage.setItem("token", "");
        }
        return { success: false, error: error.response ? error.response.data : error.message };
    }
};